module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/~/babel-runtime/core-js/object/define-property.js
// module id = ../../../../babel-runtime/core-js/object/define-property.js
// module chunks = 7